// extracted by mini-css-extract-plugin
export default {"EditDefaultDialog":"EditDefaultDialog_EditDefaultDialog__odTMa"};